import React, { useCallback, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column, ColumnBodyOptions } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { LectureInformation } from '../../../../../api/types/lecturers/details/lecture-information';
import dateUtils from '../../../../../utils/date-format';
import '../../../../../component/styles/react-prime-custom-syle.css';
import { LectureDetails } from '../../../../../api/types/lecturers/details/lecture-details';
import Colors from '../../../../../utils/colors';
import { LectureEntity } from '../../../../../api/types/programs/course/lectures/lecture-entity';
import { LecturerDetailsDb } from '../../../../../api/types/lecturers/details/lecturer-details';

interface LectureTabDialogDetailsDatamodel {
  lectureDetails?: LectureDetails;
  lectureDetailsInformation?: LectureInformation;
}

// TODO refactor the type !!
interface LectureWithLecturer {
  lecture: LectureEntity;
  lecturers: LecturerDetailsDb;
}
export const LectureTabDialogDetails: React.FC<
  LectureTabDialogDetailsDatamodel
> = ({ lectureDetails, lectureDetailsInformation }) => {
  const asdasdasd: LectureWithLecturer[] =
    lectureDetails?.sameDayLectureInformation?.flatMap((item) =>
      item.lectureDetails.lecturers.map((lecturerItem) => ({
        lecture: item.lecture,
        lecturers: lecturerItem,
      })),
    ) ?? [];
  const flattenedLectures = asdasdasd.map((item) => item.lecturers);

  const style = { width: '15%' };

  const renderSessionEndTime = (rowData: LecturerDetailsDb) => {
    if (!rowData?.sessions?.length) {
      return '';
    }
    const endAt = rowData.sessions[0].endAt;
    if (endAt === null || endAt === undefined) {
      return (
        <span style={{ color: Colors.warningText, fontWeight: 500 }}>
          טרם הסתיים
        </span>
      );
    }
    return dateUtils.formatTimeFromDate(endAt);
  };

  return (
    <div>
      <div>
        <div style={{ marginTop: '8px' }} />
        <label>מרצים</label>
        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          selectionMode={'multiple'}
          multiple={true}
          value={lectureDetailsInformation?.lecturers ?? []}
          scrollable
          onSelectionChange={(e) => {
            //setSelectedUsers(e.value as UserSummaryType[]);
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '8px',
          }}
        >
          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שם המרצה"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => (
              <div>
                {rowData.lecturer.firstName} {rowData.lecturer.lastName}
              </div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px', width: '15%' }}
            field="שלוחה"
            header="סוג פעילות"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => (
              <div>{rowData.activityType.typeRateName}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="מעמד"
            header="מעמד"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData, options: ColumnBodyOptions) => (
              <div>{options.rowIndex === 0 ? 'ראשי' : 'משני'}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שעת התחלה"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => (
              <div>
                <div>
                  {rowData?.sessions?.length > 0
                    ? dateUtils.formatTimeFromDate(rowData.sessions[0].startAt)
                    : ''}
                </div>

                {/*                <Tag
                  style={{ height: '20px' }}
                  severity={'warning'}
                  value={'איחור של 0:15+'}
                />
                <label style={{ fontSize: '14px', color: Colors.warningText }}>
                  +00:15
                </label>*/}
              </div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שעת סיום"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => (
              <div>{renderSessionEndTime(rowData)}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="סטטוס"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb, options: ColumnBodyOptions) =>
              !rowData?.sessions || rowData.sessions.length === 0 ? (
                <Tag
                  className={'neutral-tag'}
                  severity={'secondary'}
                  value={'השיעור טרם בוצע'}
                />
              ) : rowData.sessions[0].endAt === null ? (
                <Tag severity={'warning'} value={'השיעור טרם נסגר'} />
              ) : (
                <Tag severity={'success'} value={'הסתיים בהצלחה'} />
              )
            }
          />
        </DataTable>
        <div style={{ marginTop: '16px' }} />
        <label>הרצאות נוספות באותו היום</label>
        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          selectionMode={'multiple'}
          multiple={true}
          value={flattenedLectures}
          scrollable
          onSelectionChange={(e) => {
            //setSelectedUsers(e.value as UserSummaryType[]);
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '8px',
          }}
        >
          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שם המרצה"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => {
              return (
                <div>
                  {rowData.lecturer.firstName} {rowData.lecturer.lastName}
                </div>
              );
            }}
          />

          <Column
            style={{ textAlign: 'right', height: '40px', width: '15%' }}
            field="שלוחה"
            header="סוג פעילות"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => (
              <div>{rowData.activityType.typeRateName}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px', width: '15%' }}
            field="שלוחה"
            header="מעמד"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => <div>ראשי</div>}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שעת התחלה"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => (
              <div>
                {rowData?.sessions?.length > 0 ? (
                  <div>
                    <div>
                      {rowData?.sessions?.length > 0
                        ? dateUtils.formatTimeFromDate(
                            rowData.sessions[0].startAt,
                          )
                        : 'טרם בוצע'}
                    </div>

                    {/*                    <Tag
                      style={{ height: '20px' }}
                      severity={'warning'}
                      value={'איחור של 0:15+'}
                    />
                    <label
                      style={{ fontSize: '14px', color: Colors.warningText }}
                    >
                      +00:15
                    </label>*/}
                  </div>
                ) : (
                  <div>טרם בוצע</div>
                )}
              </div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שעת סיום"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb) => (
              <div>{renderSessionEndTime(rowData)}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="סטטוס"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
              ...style,
            }}
            body={(rowData: LecturerDetailsDb, options: ColumnBodyOptions) =>
              !rowData?.sessions || rowData.sessions.length === 0 ? (
                <Tag
                  className={'neutral-tag'}
                  severity={'secondary'}
                  value={'השיעור טרם בוצע'}
                />
              ) : rowData.sessions[0].endAt === null ? (
                <Tag severity={'warning'} value={'השיעור טרם נסגר'} />
              ) : (
                <Tag severity={'success'} value={'הסתיים בהצלחה'} />
              )
            }
          />
        </DataTable>
      </div>
      {/*<CalendarCreateSchedule />*/}
    </div>
  );
};
